import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyBhpjgxbwLWKlA0mehwgWHdPSoC_dMMRB4",
  authDomain: "emorya-gcp.firebaseapp.com",
//  authDomain:"app.firebaseapp.com",
  projectId: "emorya-gcp",
  storageBucket: "emorya-gcp.appspot.com",
  messagingSenderId: "177375814000",
  appId: "1:177375814000:web:327b4e2e55f590e81aefb5",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);





